import taxonomyAPIFactory from "../taxonomy/api"

const api = taxonomyAPIFactory({ taxonomyId: 'equipment' })

export default api